/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function (a) {
    a.fn.prepareTransition = function () {
        return this.each(function () {
            var b = a(this);
            b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                b.removeClass("is-transitioning")
            });
            var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
            var d = 0;
            a.each(c, function (a, c) {
                d = parseFloat(b.css(c)) || d
            });
            if (d != 0) {
                b.addClass("is-transitioning");
                b[0].offsetWidth
            }
        })
    }
})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e, r, a) {
    var n = new RegExp("(" + r + "=).*?(&|$)"), c = e;
    return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') {
    Shopify = {};
}
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function (cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = (format || this.money_format);

        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

Shopify.handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
    timber.cache = {
        // General
        $html: $('html'),
        $body: $(document.body),

        // Navigation
        $navigation: $('#AccessibleNav'),
        $mobileSubNavToggle: $('.mobile-nav__toggle'),

        // Customer Pages
        $recoverPasswordLink: $('#RecoverPassword'),
        $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
        $recoverPasswordForm: $('#RecoverPasswordForm'),
        $customerLoginForm: $('#CustomerLoginForm'),
        $passwordResetSuccess: $('#ResetSuccess')
    };
};

timber.init = function () {
    timber.improveA11y();
    timber.cacheSelectors();
    timber.accessibleNav();
    timber.drawersInit();
    timber.mobileNavToggle();
    timber.responsiveVideos();
    timber.loginForms();
    if (customerCountryDetect) {
        customerCountryDetect.init($);
    }
    $('.search-bar input').on('keyup', function (e) {
        if (event.keyCode === 13) {
            $(this).closest('form').submit();
        }
    });
    if (window.location.hash === '#secret') {
        timber.cache.$body.addClass('has-secret-url-hash');
    }
    $(document).ready(function () {
        if (typeof GIP !== 'undefined' && typeof GIP.getLocalizeData !== 'undefined') {
            GIP.getLocalizeData().then(function (data) {
                if (data) {
                    if (data.Currency && data.Currency !== 'USD') {
                        timber.cache.$body.addClass('no-afterpay');
                        window.current_shop_currency = data.Currency;
                        $(document).trigger('shop_currency_determined', data.Currency);
                    } else {
                        window.current_shop_currency = 'USD';
                        $(document).trigger('shop_currency_determined', 'USD');
                    }
                } else {
                    window.current_shop_currency = 'USD';
                    $(document).trigger('shop_currency_determined', 'USD');
                }
            });
        } else {
            $(document).trigger('shop_currency_determined', 'USD');
            window.current_shop_currency = 'USD';
        }
        $('body').addClass('all-page-loaded');
    });

    window.ba_added_meta_viewport_remove_timer_ran = 0;

    function removeAddedMetaViewport() {
        var meta_viewport_elements = document.querySelectorAll('meta[name="viewport"]');
        if (meta_viewport_elements.length > 1) {
            for (var i = 0; i < meta_viewport_elements.length; i++) {
                if (meta_viewport_elements[i].content.indexOf('user-scalable=no') > -1) {
                    meta_viewport_elements[i].parentNode.removeChild(meta_viewport_elements[i]);
                    clearInterval(window.ba_added_meta_viewport_remove_timer);
                    break;
                }
            }
        } else {
            window.ba_added_meta_viewport_remove_timer_ran++;
            if (window.ba_added_meta_viewport_remove_timer_ran > 10) {
                clearInterval(window.ba_added_meta_viewport_remove_timer);
            }
        }
    }

    window.ba_added_meta_viewport_remove_timer = setInterval(removeAddedMetaViewport, 1000);
    removeAddedMetaViewport();
    timber.footerNewsletterInit();
    timber.processProductSetsData();
};

timber.changeNavTeaser = function (content) {
    const announcements = document.querySelector('[data-announcements]');
    const visibleAnnouncement = document.querySelector('.announcement-slide--visible');
    if (!visibleAnnouncement || !announcements) return;

    const notices = visibleAnnouncement.querySelector('.announcement-slide__notices');
    if (!notices) return;

    visibleAnnouncement.classList.add('announcement-slide--notice-visible');
    notices.innerHTML = content;
    announcements.setAttribute('data-paused', 'true');
    setTimeout(function () {
        visibleAnnouncement.classList.remove('announcement-slide--notice-visible');
        notices.innerHTML = '';
        announcements.removeAttribute('data-paused');
    }, 10000);
}

timber.getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

timber.accessibleNav = function () {
    var $nav = timber.cache.$navigation,
        $allLinks = $nav.find('a'),
        $topLevel = $nav.children('li').find('a'),
        $parents = $nav.find('.site-nav--has-accordion'),
        $subMenuLinks = $nav.find('.site-nav__accordion').find('a');

    var $topDropdownLinks = $parents.find('>.site-nav__link');
    $topDropdownLinks.each(function () {
        $(this).attr('role', 'button');
        $(this).attr('aria-expanded', 'false');
        $(this).attr('aria-label', 'Opens dropdown for ' + $(this).text());
    });

    $topDropdownLinks.on('click', function (even) {
        even.preventDefault();
        var $parent = $(this).parent();
        var $icon = $(this).find('.icon');
        if ($parent.hasClass('active')) {
            $parent.removeClass('active');
            $parent.removeClass('active-accesibility');
            $icon.removeClass('icon-minus').addClass('icon-plus');
            $(this).attr('aria-expanded', 'false');
        } else if ($('body').hasClass('using-keyboard')) {
            $parents.removeClass('active');
            $parents.removeClass('active-accesibility');
            $parents.find('.icon').removeClass('icon-minus').addClass('icon-plus');
            $parent.addClass('active');
            $parent.addClass('active-accesibility');
            $icon.removeClass('icon-plus').addClass('icon-minus');
            $parent.find('div a, ul a').eq(0).focus();
            $(this).attr('aria-expanded', 'true');
        }
    });
};

timber.improveA11y = function () {
    if (window.location.hash === '#a11y') {
        timber.cache.$body.addClass('enhanced-accesibility');
    }
    window.navigated_by_keyboard_only = false;
    window.navigation_disable_hovers = false;
    //switch to keyboard mode
    $(window).on('keyup', function (event) {
        var isTab = false;
        var isEscape = false;
        var isEnter = false;
        if (event.key !== undefined) {
            isTab = event.key === 'Tab';
            isEscape = event.key === 'Escape';
            isEnter = event.key === 'Enter';
        } else if (event.keyCode !== undefined) {
            isTab = event.keyCode === 9;
            isEscape = event.keyCode === 27;
            isEnter = event.keyCode === 13;
        }
        if (isEnter) {
            if (event.target && event.target.id === 'bookmarkit') {
                $(event.target).trigger('click');
            }
        } else if (isTab && !window.navigated_by_keyboard_only) {
            window.navigated_by_keyboard_only = true;
            timber.cache.$body.addClass('using-keyboard');
        } else if (isEscape) {
            timber.cache.$navigation.find('.active-accesibility').removeClass('active-accesibility')
                .removeClass('active').find('>.site-nav__link').attr('aria-expanded', 'false');
            if (!window.navigation_disable_hovers) {
                window.navigation_disable_hovers = true;
                timber.cache.$body.addClass('no-dropdowns-hover');
            }
            if (timber.cache.$body.hasClass('js-drawer-open-right')) {
                $('.drawer--right').find('.js-drawer-close').find('button').trigger('click');
            } else if (timber.cache.$body.hasClass('js-drawer-open-right3')) {
                $('.drawer--right3').find('.js-drawer-close').find('button').trigger('click');
            } else if (timber.cache.$body.hasClass('js-drawer-open-right2')) {
                $('.drawer--right2').find('.js-drawer-close').find('button').trigger('click');
            } else if (timber.cache.$body.hasClass('newsletter-flyout-is-active')) {
                $('#klviyo-footer-submit').trigger('click');
            }
            if (timber.cache.$body.hasClass('A-BaqpPopup-is-active')) {
                $('.BaqpPopup-close').trigger('click');
            }
            if (timber.cache.$body.hasClass('has-desktop-search-open')) {
                timber.cache.$body.removeClass('has-desktop-search-open');
            }
            var pushOwnNoBtn = $('.pushowl-optin__footer-btn-wrap').find('.js-pushowl-no-button');
            if (pushOwnNoBtn.length) {
                pushOwnNoBtn.trigger('click');
            }
            if (BaPredictiveSearch && BaPredictiveSearch.close) {
                BaPredictiveSearch.close();
            }
            var openDetails = document.querySelector('.details-disclosure[open]');
            if (openDetails) {
                openDetails.removeAttribute('open');
            }
        }
    });
    //switch to mouse mode + reenable dropdowns on hover
    document.addEventListener("mouseup", function (event) {
        $target = $(event.target);
        if (window.navigated_by_keyboard_only) {
            window.navigated_by_keyboard_only = false;
            timber.cache.$body.removeClass('using-keyboard');
        }
        if (window.navigation_disable_hovers) {
            window.navigation_disable_hovers = false;
            timber.cache.$body.removeClass('no-dropdowns-hover');
        }
        //collapse any nav dropdown opened on click or enter
        if (!$target.closest('#AccessibleNav').length) {
            var navDropdownLinks = $('.active-accesibility').find('.site-nav__link');
            if (navDropdownLinks.length) {
                navDropdownLinks.eq(0).trigger('click');
            }
        }
        if (!$target.closest('.details-disclosure').length) {
            var openDetails = document.querySelector('.details-disclosure[open]');
            if (openDetails) {
                openDetails.removeAttribute('open');
            }
        }
    });

    //mobile only
    if (window.matchMedia("(max-width: 480px)").matches) {
        $('.footer-does-expand h3').each(function () {
            $(this).attr('aria-expanded', 'false')
                .attr('role', 'button')
                .attr('aria-label', 'Toggle ' + $(this).text() + ' menu')
                .attr('tabindex', 0);
        });
    }
};

timber.scrollToTop = function () {
    if (typeof $.scrollTo == 'function') {
        $(window).scrollTo(0, 500);
    } else {
        window.scrollTo(0, 0);
    }
    $('.site-header__logo-link').eq(0).focus();
};

timber.drawersInit = function () {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
        'onDrawerOpen': ajaxCart.load
    });
    timber.RightDrawer2 = new timber.Drawers('ReviewsDrawer', 'right2');
    timber.RightDrawer3 = new timber.Drawers('UtilityDrawer', 'right3');

};

timber.mobileNavToggle = function () {
    timber.cache.$mobileSubNavToggle.on('click', function (event) {
        event.preventDefault();
        $(this).parent().toggleClass('mobile-nav--expanded');
        if ($(this).parent().hasClass('mobile-nav--expanded')) {
            $(this).find('.mobile-nav__toggle-close').focus();
        } else {
            $(this).find('.mobile-nav__toggle-open').focus();
        }
    });
};

timber.getHash = function () {
    return window.location.hash;
};

timber.responsiveVideos = function () {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
    });
};


timber.loginForms = function () {
    function showRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.show();
        timber.cache.$customerLoginForm.hide();
    }

    function hideRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.hide();
        timber.cache.$customerLoginForm.show();
    }

    timber.cache.$recoverPasswordLink.on('click', function (evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
    });

    timber.cache.$hideRecoverPasswordLink.on('click', function (evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
    });

    // Allow deep linking to recover password form
    if (timber.getHash() === '#recover') {
        showRecoverPasswordForm();
    }
};

timber.resetPasswordSuccess = function () {
    timber.cache.$passwordResetSuccess.show();
};

timber.checkAndAddScript = function (url) {
    if (!$('script[src="' + url + '"]').length) {
        timber.loadjscssfile(url, 'js');
    }
}

timber.checkAndAddStyle = function (url) {
    if (!$('link[href="' + url + '"]').length) {
        timber.loadjscssfile(url, 'css');
    }
}

timber.loadjscssfile = function (url, filetype) {
    var fileref;
    if (filetype === "js") {
        fileref = document.createElement('script');
        //fileref.setAttribute("type", "text/javascript");
        fileref.setAttribute("src", url);
    } else if (filetype === "css") {
        fileref = document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", url);
    }
    if (typeof fileref != "undefined") {
        document.body.appendChild(fileref);
    }
}


/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
    var Drawer = function (id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };

        this.$nodes = {
            parent: $('body, html'),
            page: $('#PageContainer'),
            moved: $('.is-moved-by-drawer')
        };

        this.config = $.extend(defaults, options);
        this.position = position;

        this.$drawer = $('#' + id);

        if (!this.$drawer.length) {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    };

    Drawer.prototype.init = function () {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
    };

    Drawer.prototype.open = function (evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to $nodes.page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }

        // Notify the drawer is going to open
        timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        this.$nodes.moved.addClass('is-transitioning');
        this.$drawer.prepareTransition();

        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;

        // Set focus on drawer
        this.trapFocus(this.$drawer, 'drawer_focus');

        // Run function when draw opens if set
        if (this.config.onDrawerOpen && typeof (this.config.onDrawerOpen) == 'function') {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        // Lock scrolling on mobile
        this.$nodes.page.on('touchmove.drawer', function () {
            return false;
        });


        if (this.position === 'right2') {
            this.$nodes.page.on('click.drawer', $.proxy(function (event) {
                $target = $(event.target);
                if (!$target.closest('#ReviewsDrawer').length &&
                    $('#ReviewsDrawer').is(":visible")) {
                    this.close();
                    return false;
                }
            }, this));
        } else {
            this.$nodes.page.on('click.drawer', $.proxy(function () {
                this.close();
                return false;
            }, this));
        }

        // Notify the drawer has opened
        timber.cache.$body.trigger('afterDrawerOpen.timber', this);
    };

    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) { // don't close a closed drawer
            return;
        }

        // Notify the drawer is going to close
        timber.cache.$body.trigger('beforeDrawerClose.timber', this);

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        // Ensure closing transition is applied to moved elements, like the nav
        this.$nodes.moved.prepareTransition({disableExisting: true});
        this.$drawer.prepareTransition({disableExisting: true});

        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

        this.drawerIsOpen = false;

        // Remove focus on drawer
        this.removeTrapFocus(this.$drawer, 'drawer_focus');

        this.$nodes.page.off('.drawer');

        // Notify the drawer is closed now
        timber.cache.$body.trigger('afterDrawerClose.timber', this);
        if (this.config.open) {
            var toggler = $(this.config.open + '[aria-expanded="true"]');
            if (toggler.length) {
                toggler.attr('aria-expanded', false);
                toggler.focus();
            }
        }
        $('.js-drawer-open-left, .js-drawer-open-right').blur();
    };

    Drawer.prototype.trapFocus = function ($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

        $container.attr('tabindex', '-1');

        $container.focus();

        $(document).on(eventName, function (evt) {
            if ($container[0] !== evt.target && !$container.has(evt.target).length) {
                $container.focus();
            }
        });
    };

    Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

        $container.removeAttr('tabindex');
        $(document).off(eventName);
    };

    return Drawer;
})();

timber.emailIsValid = function (email) {
    return /\S+@\S+\.\S+/.test(email);
}

timber.loadLazyDesktopImages = function () {
    $('.desktop-only-lazy-image').each(function () {
        $(this).attr('src', $(this).data('src')).removeClass('desktop-only-lazy-image');
    });
}

timber.zoomProductActivate = function (event) {
    event.preventDefault();
    jQuery(this).parent().easyZoom();
    jQuery(this).remove();
}

timber.markNewsletterEmailCollected = function () {
    var email = '';
    //attentive bit
    if (typeof window.localStorage !== 'undefined') {
        var attentive_email = window.localStorage.getItem('attentive_email_save');
        if (timber.emailIsValid(attentive_email)) {
            email = attentive_email;
        }
        if (!email) {
            var ba_email = window.localStorage.getItem('baem_save');
            ba_email = atob(ba_email);
            if (timber.emailIsValid(ba_email)) {
                email = ba_email;
            }
        }
    }
    if (email) {
        if (!ba_essentials.customer_logged_in) {
            ba_essentials.session_customer_email = email;
        }
    }
}

timber.footerNewsltterSubscribe = function () {
    var customer_country = false;
    var message_div = $('.footer-newsletter-messages');
    if (typeof window.customerCountryDetect === "object"
        && window.customerCountryDetect.country_detected
        && window.customerCountryDetect.might_be_eu_country
        && timber.cache.$body.hasClass('possible-eu-visitor')) {
        var checkbox_gdpr = $('#footer-newsletter-gdpr-checkbox');
        message_div.html('');
        if (!checkbox_gdpr.is(':checked')) {
            message_div.html('<div class="footer-newsletter-error">Please check the box below the subscribe button</div>');
            return;
        } else {
            $('#email_signup').append('<input type="hidden" name="gdpr_customer" value="yes" />'
                + '<input type="hidden" name="$consent" id="consent-email" value="email">')
                .find('[name="$fields"]').attr('value', 'birthday,$consent,gdpr_customer');
        }
    }
    var email_string = $('#footer-newsletter-input').val();
    var footer_newsletter_div = $('.footer-newsletter');

    footer_newsletter_div.addClass('loading');

    if (!email_string.match(/^[^\@]+@.*\.[a-z]{2,6}$/i)) {
        message_div.html('<div class="footer-newsletter-error">Email address is not valid.</div>');
        footer_newsletter_div.removeClass('loading');
    } else {
        timber.cache.$body.trigger('footerNewsletter.subscribe', [email_string]);
        $('#k_id_email').val(email_string);
        $('.newsletter-flyout-overlay').addClass('active');
        timber.cache.$body.addClass('newsletter-flyout-is-active');
        $('.newsletter-flyout').addClass('active').attr('aria-hidden', 'false');
        setTimeout(function () {
            $('.newsletter-flyout').focus();
        }, 100);
        if (typeof window.localStorage !== 'undefined') {
            window.localStorage.setItem('baem_save', btoa(email_string));
            if (timber.markNewsletterEmailCollected) {
                timber.markNewsletterEmailCollected();
            }
        }
    }
}

timber.footerNewsletterInit = function () {
    $('#klviyo-footer-submit, #newsletter-flyout-overlay, .newsletter-flyout-close').on('click', function () {
        if (!$(this).hasClass('klaviyo_submit_button')) {
            $('#klviyo-footer-submit').trigger('click');
        } else {
            $('.newsletter-flyout-overlay').removeClass('active');
            $('.newsletter-flyout').removeClass('active').attr('aria-hidden', 'true');
            $('body').removeClass('newsletter-flyout-is-active');
            $('.footer-newsletter').removeClass('loading');
            setTimeout(function () {
                var error_message_box = $('#email_signup').find('.error_message');
                var error_message = error_message_box.text();
                if (error_message) {
                    $('.footer-newsletter-messages').html('<div class="footer-newsletter-error">' + error_message + '</div>');
                    error_message_box.text('');
                }
            }, 300);
        }
    });
    $('#footer-newsletter-email').on('submit', function (event) {
        event.preventDefault();
    });
    $('#footer-newsletter-input').on('keyup', function (event) {
        var isEnter = false;
        if (event.key !== undefined) {
            isEnter = event.key === 'Enter';
        } else if (event.keyCode !== undefined) {
            isEnter = event.keyCode === 13;
        }
        if (isEnter) {
            timber.footerNewsltterSubscribe();
        }
    });
}

timber.processProductSetsData = function () {
    ba_essentials.unlistable_p_ids = ba_essentials.unlistable_p_ids || [];
    var ProductSetsMetafieldData = $('#ProductSetsMetafieldData').html();
    if (ProductSetsMetafieldData) {
        try {
            ba_essentials.product_sets_data = JSON.parse(ProductSetsMetafieldData);
        } catch (err) {
            console.error(err);
        }
    }
    if (ba_essentials.product_sets_data && ba_essentials.product_sets_data.children_ids.length) {
        ba_essentials.unlistable_p_ids = ba_essentials.unlistable_p_ids.concat(ba_essentials.product_sets_data.children_ids);
    }
};

// Initialize Timber's JS on docready
$(timber.init);
timber.markNewsletterEmailCollected();

$(document).ready(function () {
    var html_el = $('html');
    html_el.removeClass('temp-supports-fontface').addClass('should-be-fully-loaded');
    var margintop = 1;
    if (window.matchMedia("(min-width: 768px)").matches) {
        margintop = $('.announcement-slide--visible').height() || 0; // because we change this often
        function toggleDesktopStickyHeader() {
            if (!margintop || $(window).scrollTop() > margintop) {
                $('.site-header').addClass('new-sticky-to-top').removeClass('non-stycky-to-top');
            } else {
                $('.site-header').removeClass('new-sticky-to-top').addClass('non-stycky-to-top');
            }
        }

        if (margintop > 0) {
            document.addEventListener('scroll', toggleDesktopStickyHeader, {passive: true});
        }
        toggleDesktopStickyHeader();
        timber.loadLazyDesktopImages();

        function toggleHeaderSearch (event) {
            event.preventDefault(); event.stopPropagation();
            if (timber.cache.$body.hasClass('has-desktop-search-open')) {
                timber.cache.$body.removeClass('has-desktop-search-open');
            } else {
                timber.cache.$body.addClass('has-desktop-search-open');
                document.querySelector('#header-search-fixed [name="q"]').focus();
            }
        }

        $('[data-desktop-search-trigger]').on('click', toggleHeaderSearch);
        $('[data-desktop-search-close]').on('click', function (event) {
            event.preventDefault();
            timber.cache.$body.removeClass('has-desktop-search-open');
        });
    } else {
        margintop = 24;
        var mobileSiteHeader = $('.site-header');
        function toggleMobileHeaderStickyness () {
            if ($(window).scrollTop() > margintop) {
                if (!mobileSiteHeader.hasClass('mobile_sticky_top')) {
                    mobileSiteHeader.addClass('mobile_sticky_top').removeClass('non-stycky-to-top');
                    timber.cache.$body.addClass('has-mobile-header-sticky');
                }
            } else {
                if (!mobileSiteHeader.hasClass('non-stycky-to-top')) {
                    mobileSiteHeader.removeClass('mobile_sticky_top').addClass('non-stycky-to-top');
                    timber.cache.$body.removeClass('has-mobile-header-sticky');
                }
            }
        }
        document.addEventListener('scroll', toggleMobileHeaderStickyness, {passive: true});
        toggleMobileHeaderStickyness();
        $('.mobile-only-lazy-image').each(function () {
            $(this).attr('src', $(this).data('src'));
        });
    }
    $('#mobile-search-trigger').on('click', function (event) {
        event.preventDefault();
        var searchInput = $('#header-search-fixed [name="q"]');
        searchInput.removeAttr('placeholder');
        if (timber.cache.$body.hasClass('mobile-search-is-open')) {
            timber.cache.$body.removeClass('mobile-search-is-open');
            $(this).attr('aria-expanded', 'false');
        } else {
            timber.cache.$body.addClass('mobile-search-is-open');
            searchInput.focus();
            $(this).attr('aria-expanded', 'true');
        }
    });
    $('.mobile-search-backdrop').on('click', function () {
        timber.cache.$body.removeClass('mobile-search-is-open');
    });
    // });
    window.clickOnListSwatches = function (event) {
        event.preventDefault();
        var image = $(this).data('image');
        var url = $(this).data('url');
        var option = $(this).data('option');
        var product_box = $(this).parents('.product-in-list').first();
        if (url) {
            product_box.find('.product-list-link').attr('href', url);
        }
        if (image) {
            var picture = product_box.find('picture');
            if (picture.length) {
                picture.find('.product-list-image').attr('src', image).data('swatch-image', image);
                picture.find('source').attr('srcset', image);
            } else {
                product_box.find('.product-list-image').attr('src', image).data('swatch-image', image);
            }
        }
        if (option) {
            product_box.attr("data-selectedfinish", option);
        }
        product_box.find('.list-option-switch').removeClass('active');
        $(this).addClass('active');
    };
    $('.list-option-switch').on('click', window.clickOnListSwatches);
    $('.faq-group').on('click', function (event) {
        if ($(event.target).hasClass('faq-group') || $(event.target).hasClass('question')) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('.question').attr('aria-expanded', false);
            } else {
                $(this).addClass('active');
                $(this).find('.question').attr('aria-expanded', true);
            }
        }
    });
    var uAgent = window.navigator.userAgent;
    var msie = uAgent.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        timber.cache.$body.addClass('browser-is-ie');
    } else {
        timber.cache.$body.addClass('browser-isnot-ie');
    }
    $('.footer-does-expand h3').on('click', function () {
        var parent = $(this).parent();
        if (parent.hasClass('active')) {
            parent.removeClass('active');
            if ($(this).attr('role') === 'button') {
                $(this).attr('aria-expanded', 'false');
            }
        } else {
            parent.addClass('active');
            if ($(this).attr('role') === 'button') {
                $(this).attr('aria-expanded', 'true');
            }
        }
    });
    $('.footer-about-nav__link').each(function () {
        if ($(this).text() === 'Jewelry Care') {
            $(this).addClass('mfp-magic-block');
            $(this).attr('data-divId', 'JewelryCareTemplate');
            $(this).attr('data-class', 'closeIconInsideMfp');
            $(this).attr('aria-label', 'Open Jewelry Care Popup');
            $(this).attr('data-popuplabel', 'Jewelry Care Popup');
            $(this).attr('role', 'button');
            return false;
        }
    });
    window.onClickMfpMagicImage = function (event) {
        var capture_click = true;
        if (window.magnificPopupJsUrl) {
            timber.checkAndAddScript(window.magnificPopupJsUrl);
        } else {
            capture_click = false;
        }
        if (window.magnificPopupCssUrl) {
            timber.checkAndAddStyle(window.magnificPopupCssUrl);
        } else {
            capture_click = false;
        }
        if (!capture_click) {
            return;
        }
        event.preventDefault();
        var waited_for = 0;
        var image_url = $(this).attr('href');
        var ariaLabel = '', imgAlt;
        if ($(this).data('popuplabel')) {
            ariaLabel = $(this).data('popuplabel');
        }
        if ($(this).data('imgalt')) {
            imgAlt = $(this).data('imgalt');
        } else if (ariaLabel) {
            imgAlt = ariaLabel;
        }

        function openMfpPopup() {
            if (typeof $.magnificPopup == 'undefined') {
                if (waited_for < 1100) {
                    setTimeout(openMfpPopup, 100);
                    waited_for += 100;
                }
                return;
            }
            $.magnificPopup.open({
                items: {
                    src: image_url
                },
                type: 'image',
                callbacks: {
                    open: function () {
                        var focusModal = $('.mfp-image-holder').find('.mfp-figure');
                        if (ariaLabel) {
                            focusModal.attr('aria-label', ariaLabel);
                            focusModal.attr('role', 'dialog');
                        }
                        focusModal.find('.mfp-close').attr('aria-label', 'Close popup');
                        focusModal.find('.mfp-img').attr('alt', imgAlt);
                    }
                }
            });
        }

        openMfpPopup();
    };
    window.onClickMfpMagicDiv = function (event) {
        var capture_click = true;
        if (window.magnificPopupJsUrl) {
            timber.checkAndAddScript(window.magnificPopupJsUrl);
        } else {
            capture_click = false;
        }
        if (window.magnificPopupCssUrl) {
            timber.checkAndAddStyle(window.magnificPopupCssUrl);
        } else {
            capture_click = false;
        }
        if (!capture_click) {
            return;
        }
        var divId = $(this).data('divId') || $(this).data('divid');
        var classes = $(this).data('class');
        if (!classes || !divId) {
            return;
        }
        var ariaLabel = '';
        if ($(this).data('popuplabel')) {
            ariaLabel = ' aria-label=" ' + $(this).data('popuplabel') + '" role="dialog"';
        }
        event.preventDefault();
        var waited_for = 0;

        function openDivMfpPopup() {
            if (typeof $.magnificPopup == 'undefined') {
                if (waited_for < 1600) {
                    setTimeout(openDivMfpPopup, 100);
                    waited_for += 100;
                }
                return;
            }
            $.magnificPopup.open({
                items: {
                    src: '<div class="Mp-' + divId + ' ' + classes
                        + '"' + ariaLabel + '>' + $('#' + divId).html() + '</div>',
                    type: 'inline'
                },
                callbacks: {
                    open: function () {
                        var focusModal = $('.Mp-' + divId);
                        focusModal.find('.mfp-close').attr('aria-label', 'Close popup');
                        focusModal.prepend(focusModal.find('.mfp-close'))
                    }
                }
            });
        }

        openDivMfpPopup();
    };
    $('.mfp-magic-image').on('click', window.onClickMfpMagicImage);
    $('.mfp-magic-block').on('click', window.onClickMfpMagicDiv);
    $('.shoppay-info-link').on('click', function(event) {
        var shop_pay_element = $('#shop-pay-original-terms').find('shopify-payment-terms');
        if (shop_pay_element.length) {
            shop_pay_element = shop_pay_element.get(0);
            var shop_pay_learn_more = shop_pay_element.shadowRoot.querySelector('#shopify-installments-cta');
            if (shop_pay_learn_more) {
                event.preventDefault();
                shop_pay_learn_more.click();
                return;
            }
        }
        var onClickMfpMagicDiv = window.onClickMfpMagicDiv.bind(this);
        onClickMfpMagicDiv(event);
    });
    $('body').on('click', '.switch-to-usd-button', function (event) {
        event.preventDefault();
        var current_location = window.location.href.split('#')[0];
        if (current_location.indexOf('?') > 1) {
            window.location.href = current_location + '&currency=USD';
        } else {
            window.location.href = current_location + '?currency=USD';
        }
    });


    let announcementSlides = document.querySelectorAll('[data-announcement-slide]');
    let announcements = document.querySelector('[data-announcements]');
    if (announcementSlides.length > 1) {
        const changeInterval = parseInt(announcements.dataset.slideInterval) * 1000;

        function changeAnnouncementSlide() {
            if (announcements.dataset.paused) return;

            let setNewSlide = false, unsetOldSlide = false;

            announcementSlides.forEach(function (announcementSlide) {
                if (announcementSlide.classList.contains('announcement-slide--visible')) {
                    announcementSlide.classList.remove('announcement-slide--visible');
                    unsetOldSlide = true;
                } else if (!setNewSlide && unsetOldSlide) {
                    announcementSlide.classList.add('announcement-slide--visible');
                    setNewSlide = true;
                }
            });

            if (!setNewSlide) announcementSlides[0].classList.add('announcement-slide--visible');
        }

        setInterval(changeAnnouncementSlide, changeInterval);
    }
});
!(function () {
    // create a div (could also reuse a known element
    var el = document.createElement('div');
    // detect support
    var supports_grid = typeof el.style.grid === 'string';
    // add body class
    if (supports_grid) {
        document.body.classList.add('supports-display-grid');
    }
})();

function BaJsSwatches(product, config) {
    this.product = product;
    this.config = config || {
        hide_headers: true
    };
    this.prefix = config.prefix || 'bajsswtch';
    this.default_variant = config.default_variant || null;
    this.wrapper_id = 'js-swatches-' + this.prefix + '-' + this.product.id;
    this.switchVariant = this.switchVariant.bind(this);
    try {
        this.option_images = JSON.parse($('#js-swatch-images').html());
    } catch (e) {
        this.option_images = {};
    }
}

BaJsSwatches.prototype.switchVariant = function (option_values) {
    var variant = null;
    for (var i = 0; i < this.product.variants.length; i++) {
        var matches = true;
        for (var j = 0; j < option_values.length; j++) {
            if (option_values[j] !== this.product.variants[i].options[j]) {
                matches = false;
                break;
            }
        }
        if (matches) {
            variant = this.product.variants[i];
            break;
        }
    }
    this.swatch_element.find('.js-swatch-variant-id').val(variant ? variant.id : '');
    if (typeof this.config.switchVariantCallback === 'function') {
        this.config.switchVariantCallback(variant, this.swatch_element);
    }
}

BaJsSwatches.prototype.activate = function (parent) {
    var swatch_element = parent ? parent.find('#' + this.wrapper_id) : $('#' + this.wrapper_id);
    this.swatch_element = swatch_element;
    var option_count = this.product.options.length;
    var switchVariant = this.switchVariant;
    this.swatch_element.find('input').on('change', function () {
        var values = [];
        var options = $(this).closest('.js-swatches-wrap').find('input[type="radio"]');
        options.each(function () {
            if ($(this).is(':checked')) {
                values.push($(this).val());
            }
        });
        if (option_count === values.length) {
            switchVariant(values);
        }
    });
    if (this.default_variant) {
        for (var i = 0; i < this.default_variant.options.length; i++) {
            swatch_element.find('input[value=' + JSON.stringify(this.default_variant.options[i]) + ']')
                .prop('checked', true).trigger('change');
        }
    }
}

BaJsSwatches.prototype.getColorByName = function (name) {
    if (name.indexOf('White') > -1) {
        return '#f9f9f9';
    }
    if (name.indexOf('Black') > -1) {
        return '#222';
    }
    switch (name) {
        case '14k Gold':
        case 'Gold Vermeil':
            return '#f2e0c4';
        case 'Silver':
        case 'Sterling Silver':
            return '#dddddd';
        case 'Rose Gold':
            return '#ead8cc';
        case 'Crystal':
            return '#eee';
        case 'Tan':
            return '#e3ddda';
        case 'Grey':
            return '#f2f1f6';
        default:
            return name.toLowerCase().split(' ')[0];
    }
}

BaJsSwatches.prototype.getMarkup = function () {
    var html = '';
    if (!this.default_variant) {
        for (var z = 0; z < this.product.variants.length; z++) {
            if (this.product.variants[z].available) {
                this.default_variant = this.product.variants[z];
                break;
            }
        }
        if (!this.default_variant) {
            this.default_variant = this.product.variants[0];
        }
    }
    for (var i = 0; i < this.product.options.length; i++) {
        var swatch = this.product.options[i];
        var swatch_name = typeof swatch === 'object' ? swatch.name : swatch;
        var length_class_prefix = '';
        var option_index = i;
        var is_color = false;
        var downcased_option = swatch_name.toLowerCase();
        if (downcased_option.indexOf('finish') > -1 || downcased_option.indexOf('stone') > -1
            || downcased_option.indexOf('color') > -1 || downcased_option.indexOf('style') > -1) {
            is_color = true;
        }
        if (downcased_option.indexOf('length') > -1) {
            length_class_prefix = 'len';
        }
        html += '<fieldset class="js-swatch swatch clearfix swatch-' + Shopify.handleize(downcased_option)
            + '" data-product_id="' + this.product.id + '" data-option-index="' + option_index + '">';
        if (!this.config.hide_headers) {
            html += '<div class="header">' + ba_essentials.htmlEscape(swatch_name) + '</div>';
        }
        var all_option_values = [];
        var option_images = this.option_images;
        for (var j = 0; j < this.product.variants.length; j++) {
            var variant = this.product.variants[j];
            var current_option_val = variant.options[option_index];
            if (all_option_values.indexOf(current_option_val) > -1) {
                continue;
            }
            var bg_image = (function(handle) {
                var image = option_images[handle];
                if (!image && option_images['template']) {
                    image = option_images['template'].replace('template', handle)
                }

                return image;
            })(Shopify.handleize(current_option_val));
            all_option_values.push(current_option_val);
            var option_quoted = JSON.stringify(current_option_val);
            var input_name = this.prefix + String(this.product.id) + '-' + String(option_index);
            var input_id = input_name + Shopify.handleize(current_option_val);
            html += '<div data-value=' + option_quoted + ' class="swatch-element ' + (is_color ? 'color' : '') + '">';
            html += '<input type="radio" value=' + option_quoted + ' id="' + input_id + '" name="' + input_name
                + '" aria-label="' + ba_essentials.htmlEscape(swatch_name) + ' ' + ba_essentials.htmlEscape(current_option_val) + '" />';
            html += '<label for="' + input_id + '" ' + (is_color ? (
                ' style="background-color: ' + this.getColorByName(current_option_val) + '; '
                + (bg_image ? ('background-image: url(' + bg_image + ');') : '')
                + '" title="' + ba_essentials.htmlEscape(current_option_val) + '"') : '')
                + '>'
                + (!is_color ? ba_essentials.htmlEscape(current_option_val) : '');
            html += '</label></div>';
        }
        html += '</fieldset>';
    }
    html += '<input data-js-swatch-variant-id type="hidden" class="js-swatch-variant-id" name="' + (this.config.inputname || 'id') + '" value="" />';
    return '<div class="js-swatches-wrap" id="' + this.wrapper_id + '">' + html + '</div>';
}